import React from "react";
import { Navigate } from "react-router-dom";
//Tables

import Alt404 from "../pages/AuthenticationInner/Errors/Alt404";
import Basic404 from "../pages/AuthenticationInner/Errors/Basic404";
import Cover404 from "../pages/AuthenticationInner/Errors/Cover404";
import Error500 from "../pages/AuthenticationInner/Errors/Error500";
import Offlinepage from "../pages/AuthenticationInner/Errors/Offlinepage";
import BasicLogout from "../pages/AuthenticationInner/Logout/BasicLogout";
import CoverLogout from "../pages/AuthenticationInner/Logout/CoverLogout";

//login
import ApiKey from "../pages/APIKey/index";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";

// User Profile
import UserProfile from "../pages/Authentication/user-profile";

//MenuInfo

import ResetPassword from "../pages/Authentication/ResetPassword";
import ChangePassword from "../pages/Authentication/ChangePassword";
import PasswordChange from "../pages/Authentication/PasswordChange";

import Registergetlist from "../pages/Authentication/Registergetlist";
import Rolesadminget from "../pages/Authentication/Rolesadminget";

import CustomerReport from "../pages/CustomerReport/CustomerReport";


import PosLayout from "../OrderingSystem/POS/Layout/page/PosLayout";
import MenuItem from "../OrderingSystem/Menu/page/MenuItem";
import Waiter from "../OrderingSystem/Waiter/page/Waiter";
import Category from "../OrderingSystem/Category/page/Category";
import CategoryCreate from "../OrderingSystem/Category/component/CategoryCreate";
import Customers from "../OrderingSystem/Customer/page/Customers";
import ItemDetail from "../OrderingSystem/Menu/component/ItemDetail";
import CategoryDetail from "../OrderingSystem/Category/page/CategoryDetail";
import TableList from "../OrderingSystem/Table/page/TableList";
import CreateTable from "../OrderingSystem/Table/component/CreateTable";
import OrderList from "../OrderingSystem/Order/page/OrderList";
import OrderDetail from "../OrderingSystem/Order/page/OrderDetail";
import CustomerDetail from "../OrderingSystem/Customer/page/CustomerDetail";
import TenantOrganization from "../OrderingSystem/Tenant/TenantOrganization";
import Organization from "../OrderingSystem/Organization/page/Organization";
import TenantDetail from "../OrderingSystem/Tenant/component/TenantDetail";

import PaymentReport from "../OrderingSystem/PaymentReport/page/PaymentReport";
import PaymentDatBook from "../OrderingSystem/PaymentReport/page/PaymentDayBook";
import Section from "../OrderingSystem/Section/page/Section";
import DetailSection from "../OrderingSystem/Section/page/DetailSection";
import DetailTable from "../OrderingSystem/Table/page/DetailTable";
import Unit from "../OrderingSystem/Unit/page/Unit";
import CustomerType from "../OrderingSystem/CustomerType/page/CustomerType";
import ItemForm from "../OrderingSystem/Menu/component/ItemForm";
import CostCenter from "../OrderingSystem/CostCenter/page/CostCenter";
import SalesReport from "../OrderingSystem/SalesReport/page/SalesReport";
import ReturnBillLogs from "../OrderingSystem/SalesReport/page/ReturnBillLogs";
import GeneratePrintToken from "../OrderingSystem/GeneratePrintToken/page/GeneratePrintToken";
import CreditLog from "../OrderingSystem/PaymentReport/page/CreditLog";
import OrderDetailsList from "../OrderingSystem/Order/page/OrderDetailsList";
import ComplimentryLog from "../OrderingSystem/ComplimentryLogs/page/ComplimentryLog";
import DetailComplementry from "../OrderingSystem/ComplimentryLogs/component/DetailComplementry";
import Register from "../pages/Authentication/Register";
import SalesReportWise from "../OrderingSystem/SalesReport/page/SalesReportWise";
import CreditLogSummary from "../OrderingSystem/PaymentReport/page/CreditLogSummary";
import Purchase from "../OrderingSystem/Purchase/Purchase";
import PurchaseForm from "../OrderingSystem/Purchase/component/PurchaseForm";
import Supplier from "../OrderingSystem/Supplier/Supplier";
import SupplierForm from "../OrderingSystem/Supplier/component/SupplierForm";
import PurchaseDetail from "../OrderingSystem/Purchase/component/PurchaseDetail";
import OrgPage from "../OrderingSystem/QRMenu/OrgPage";
import LandingPage from "../OrderingSystem/Landing/page/LandingPage";
import DaybookOrderSummary from "../Daybook/page/DaybookOrderSummary";
import PaymentTypeSummary from "../Daybook/page/PaymentTypeSummary";
import RecipeList from "../OrderingSystem/RecipeManagement/page/RecipeList";
import RecipeForm from "../OrderingSystem/RecipeManagement/component/RecipeForm";
import ReceipeDetail from "../OrderingSystem/RecipeManagement/component/ReceipeDetail";
import UnitConversion from "../OrderingSystem/Unit/page/UnitConversion";
import DayBookLogs from "../OrderingSystem/PaymentReport/page/DayBookLogs";
import DaybookLogDetail from "../OrderingSystem/PaymentReport/component/DaybookLogDetail";
import ItemPercentDetailReport from "../OrderingSystem/SalesReport/component/ItemPercentDetailReport";
import TransactionReport from "../OrderingSystem/SalesReport/page/TransactionReport";
import Dbmgmt from "../pages/DatabaseWebservice/DatabaseMgmt/page/Dbmgmt";
import DbDetailPage from "../pages/DatabaseWebservice/DatabaseMgmt/page/DbdetailPage";
import RestroUsersInfo from "../pages/DatabaseWebservice/RestroUsersInfo/page/RestroUsersInfo";
import RestroDetailPage from "../pages/DatabaseWebservice/RestroUsersInfo/page/RestroDetailPage";
import RestroUserLogs from "../pages/DatabaseWebservice/RestoUserLogs/page/RestroUserLogs";
import RestroUserLogsDetail from "../pages/DatabaseWebservice/RestoUserLogs/page/RestroUserLogsDetail";
import RestroUserQueryLogs from "../pages/DatabaseWebservice/RestroUserQueryLogs/page/RestroUserQueryLogs";
import DbdetailPage from "../pages/DatabaseWebservice/DatabaseMgmt/page/DbdetailPage";
import Usermanagement from "../pages/DatabaseWebservice/User-management/pages/Usermanagement";
import Userdetail from "../pages/DatabaseWebservice/User-management/pages/Userdetail";
import Dashboard from "../BankUX/Dashboard/Dashboard";
import DisputeListPage from "../pages/DisputeWorkFlow/pages/DisputeList/DisputeListPage";
import DisputeDetailPage from "../pages/DisputeWorkFlow/pages/DisputeDetail/DisputeDetailPage";
import MenuDetailPage from "../pages/MenuWorkflow/pages/menuDetail/MenuDetailPage";
import MenuListPage from "../pages/MenuWorkflow/pages/menuList/MenuListPage";
import BranchPage from "../pages/AdminWorkFlow/pages/Branch/BranchPage";
import DepartmentPage from "../pages/AdminWorkFlow/pages/Department/DepartmentPage";
import EmployeePage from "../pages/AdminWorkFlow/pages/Employee/EmployeePage";
import DisputeTypeData from "../pages/AdminWorkFlow/pages/DisputeTypes/DisputeTypeData";
import DisputeTypePage from "../pages/AdminWorkFlow/pages/DisputeTypes/DisputeTypePage";
import DocumentTypePage from "../pages/AdminWorkFlow/pages/DocumentTypes/DocumentTypePage";
import EmployeeDetailPage from "../pages/AdminWorkFlow/pages/Employee/EmployeeDetailPage";
import BranchDetailPage from "../pages/AdminWorkFlow/pages/Branch/BranchDetailPage";
import DepartmentDetailPage from "../pages/AdminWorkFlow/pages/Department/DepartmentDetailPage";
import DisputeTypeDetailPage from "../pages/AdminWorkFlow/pages/DisputeTypes/DisputeTypeDetailPage";
import DocumentTypeDetailPage from "../pages/AdminWorkFlow/pages/DocumentTypes/DocumentTypeDetailPage";
import AddForm from "../pages/Forms/pages/AddForm";
import UpdateForm from "../pages/Forms/pages/UpdateForm";
import InitiatedListPage from "../pages/DisputeWorkFlow/pages/memomodule/pages/InitiatedList/InitiatedListPage";
import InitiatedDetailPage from "../pages/DisputeWorkFlow/pages/memomodule/pages/InitiatedList/InitiatedDetailPage"
import PendingListPage from "../pages/DisputeWorkFlow/pages/memomodule/pages/PendingList/PendingListPage";
import PendingDetailPage from "../pages/DisputeWorkFlow/pages/memomodule/pages/PendingList/PendingDetailPage";
import CompletedListPage from "../pages/DisputeWorkFlow/pages/memomodule/pages/CompletedList/CompletedListPage";
import CompletedDetailPage from "../pages/DisputeWorkFlow/pages/memomodule/pages/CompletedList/CompletedDetailPage";
import ProcessingListPage from "../pages/DisputeWorkFlow/pages/memomodule/pages/ProcessingList/ProcessingListPage";
import ProcessingDetailPage from "../pages/DisputeWorkFlow/pages/memomodule/pages/ProcessingList/ProcessingDetailPage";
import NewListPage from "../pages/DisputeWorkFlow/pages/memomodule/pages/NewList/NewListPage";
import NewDetailPage from "../pages/DisputeWorkFlow/pages/memomodule/pages/NewList/NewDetailPage";
import DefferedListPage from "../pages/DisputeWorkFlow/pages/memomodule/pages/Deffered List/DefferedListPage";
import DefferedDetailPage from "../pages/DisputeWorkFlow/pages/memomodule/pages/Deffered List/DefferedDetailPage";


//ApprovedList

const authProtectedRoutes = [
  // { path: "/home", component: <Navigate to="/project" /> },

  //Tables

  { path: "/dashboard", component: <Dashboard /> },

  //APIkey
  { path: "/apps-api-key", component: <ApiKey /> },

  //User Profile
  { path: "/profile", component: <UserProfile /> },
  { path: "/Admin-roles", component: <Rolesadminget /> },
  { path: "/User-Role", component: <Registergetlist /> },
  { path: "/User-Role/create", component: <Register /> },
  { path: "/User-Role/edit/:id", component: <Register /> },
  // { path: "/Yup", component: <YupValidation /> },
  { path: "/change-password", component: <ChangePassword /> },

  { path: "/customer-report", component: <CustomerReport /> },

  // ==================================================
  // Ordering system
  { path: "/customer-list", component: <Customers /> },
  // { path: "/user-mgmt", component: <Usermanagement/> },
  { path: "/user-mgmt", component: <Usermanagement  /> },
  {
    path: "/customer/:id",
    component: <CustomerDetail />,
  },
  
  { path: "/staff", component: <Waiter /> },
  { path: "/category-list", component: <Category /> },
  { path: "/db", component: <Dbmgmt /> },
  { path: "/restrousers", component: <RestroUsersInfo /> },
  { path: "/restrouserslogs", component: <RestroUserLogs /> },
  { path: "/restrousersquerylogs", component: <RestroUserQueryLogs /> },
  { path: "/disputeList", component: <DisputeListPage /> },
  { path: "/completedList", component: <CompletedListPage /> },
  { path: "/processingList", component: <ProcessingListPage /> },
  { path: "/newList", component: <NewListPage /> },
  { path: "/defferedList", component: <DefferedListPage /> },
  { path: "/defferedList/:id", component: <DefferedDetailPage /> },
  { path: "/newList/:id", component: <NewDetailPage /> },
  { path: "/processingList/:id", component: <ProcessingDetailPage /> },
    { path: "/completedList/:id", component: <CompletedDetailPage /> },
  { path: "/disputeDetail/:id", component: <DisputeDetailPage /> },
  { path: "/initiatedList", component: <InitiatedListPage /> },
  { path: "/initiatedList/:id", component: <InitiatedDetailPage /> },
  { path: "/pendingList", component: <PendingListPage/> },
  { path: "/pendingList/:id", component: <PendingDetailPage /> },
  { path: "/menuDetail", component: <MenuDetailPage /> },
  { path: "/menuList", component: <MenuListPage /> },
  { path: "/menuList", component: <MenuListPage /> },
  { path: "/addForm/:type", component: <AddForm /> },
  { path: "/updateForm/:type", component: <UpdateForm /> },
{ path: "/branch", component: <BranchPage /> },
{ path: "/dispute", component: <DisputeTypePage /> },
{ path: "/document", component: <DocumentTypePage /> },
{ path: "/department", component: <DepartmentPage /> },
{ path: "/employee", component: <EmployeePage /> },
{ path: "/employee/detail/:empCode", component: <EmployeeDetailPage /> },
{ path: "/branch/detail/:branchId", component: <BranchDetailPage /> },
{ path: "/department/detail/:departmentCode", component: <DepartmentDetailPage /> },
{ path: "/dispute/detail/:disputeCode", component: <DisputeTypeDetailPage /> },
{ path: "/document/detail/:docCode", component: <DocumentTypeDetailPage /> },

{
    path: "/User/:id",
    component: <Userdetail />,
  },

  {
    path: "/category/create",
    component: <CategoryCreate />,
  },
  {
    path: "/category/update/:id",
    component: <CategoryCreate />,
  },
  {
    path: "/category-detail/:id",
    component: <CategoryDetail />,
  },
  { path: "/menu-item", component: <MenuItem /> },
  { path: "/menu-item/create", component: <ItemForm /> },
  { path: "/menu-item/update/:id", component: <ItemForm /> },

  {
    path: "/item/detail/:id",
    component: <ItemDetail />,
  },
  { path: "/table", component: <TableList /> },
  { path: "/table/create", component: <CreateTable /> },
  { path: "/table/update/:id", component: <CreateTable /> },
  { path: "/table/detail/:id", component: <DetailTable /> },

  { path: "/order", component: <OrderList /> },
  { path: "/order-detail", component: <OrderDetailsList /> },
  {
    path: "/order/:id",
    component: <OrderDetail />,
  },

  { path: "/tenant", component: <TenantOrganization /> },
  { path: "/tenant/detail/:id", component: <TenantDetail /> },

  { path: "/organization", component: <Organization /> },

  { path: "/pos", component: <PosLayout /> },
  { path: "/payment/statement", component: <PaymentReport /> },
  { path: "/day-book", component: <PaymentDatBook /> },

  // payment type page

  { path: "/section", component: <Section /> },
  { path: "/section/detail/:id", component: <DetailSection /> },

  { path: "/unit", component: <Unit /> },
  { path: "/unit-conversion", component: <UnitConversion /> },
  { path: "/customer-type", component: <CustomerType /> },

  { path: "/cost-center", component: <CostCenter /> },
  { path: "/sales-report", component: <SalesReport /> },
  { path: "/sales-report/wise", component: <SalesReportWise /> },
  { path: "/transaction/report", component: <TransactionReport /> },
  { path: "/transaction/report/:id", component: <TransactionReport /> },

  { path: "/return-bill-report", component: <ReturnBillLogs /> },
  { path: "/generate-print-token", component: <GeneratePrintToken /> },

  { path: "/credit-logs/customer/:id", component: <CreditLog /> },
  { path: "/credit-logs/summary", component: <CreditLogSummary /> },

  { path: "/complimentry-logs", component: <ComplimentryLog /> },
  { path: "/complimentry-logs/detail/:id", component: <DetailComplementry /> },

  { path: "/purchase", component: <Purchase /> },
  { path: "/purchase/create", component: <PurchaseForm /> },
  { path: "/purchase/update/:id", component: <PurchaseForm /> },
  { path: "/purchase/detail/:id", component: <PurchaseDetail /> },

  { path: "/suppliers", component: <Supplier /> },
  { path: "/suppliers/create", component: <SupplierForm /> },
  { path: "/suppliers/update/:id", component: <SupplierForm /> },

  { path: "/dayclose/order-summary", component: <DaybookOrderSummary /> },
  { path: "/dayclose/payment-type-summary", component: <PaymentTypeSummary /> },

  // receipe management-----------------------------
  { path: "/receipe-management", component: <RecipeList /> },
  { path: "/receipe-management/create", component: <RecipeForm /> },
  { path: "/receipe-management/update/:id", component: <RecipeForm /> },
  { path: "/receipe/detail/:id", component: <ReceipeDetail /> },
  { path: "/db/detail/:id", component: <DbdetailPage /> },
  { path: "/restro/detail/:apiKey", component: <RestroDetailPage /> },
  { path: "/restrolog/detail/:apiKey", component: <RestroUserLogsDetail /> },
  // { path: "/restrouserssummary", component: <RestroUserLogsSummary /> },
  // { path: "/users-expired", component: <Restrouserexpired /> },

  { path: "/logs/day-book", component: <DayBookLogs /> },
  { path: "/logs/day-book/:id", component: <DaybookLogDetail /> },

  { path: "/percent-wise-item/all/", component: <ItemPercentDetailReport /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/", component: <Login /> },

  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/org-register", component: <Register /> },

  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/reset-password", component: <ResetPassword /> },

  { path: "/forgot-password-change", component: <PasswordChange /> },

  //AuthenticationInner pages
  // { path: "/auth-signin-basic", component: <BasicSignIn /> },
  // { path: "/auth-signin-cover", component: <CoverSignIn /> },
  { path: "/auth-logout-basic", component: <BasicLogout /> },
  { path: "/auth-logout-cover", component: <CoverLogout /> },
  { path: "/auth-404-basic", component: <Basic404 /> },
  { path: "/auth-404-cover", component: <Cover404 /> },
  { path: "/auth-404-alt", component: <Alt404 /> },
  { path: "/auth-500", component: <Error500 /> },
  { path: "/auth-offline", component: <Offlinepage /> },

  {
    path: "/:orgcode",
    component: <OrgPage />,
  },

  {
    path: "/:orgcode/:page",
    component: <OrgPage />,
  },
  {
    path: "/:orgcode/:page/:subPage",
    component: <OrgPage />,
  },
  {
    path: "*",
    component: <OrgPage />,
  },
];

export { authProtectedRoutes, publicRoutes };
